module.exports = __webpack_public_path__ + "static/media/corodata.f4b09a52.png";